import axiosConfig from "./axiosConfig";
import { HealthEvent } from "./getSiteHealthEvents";

export interface CreateManualHealthEventRequest {
  esysUuid?: string | null;
  category: string;
  checkType: string;
  severity: string;
  detectedAt: string;
  resolvedAt?: string | null;
  impactType: string;
  summary: string;
  notes?: string;
  details?: Record<string, unknown>;
}

const createManualHealthEvent = async (
  authToken: string,
  siteId: string,
  event: CreateManualHealthEventRequest
): Promise<HealthEvent> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/health/events`,
    event,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default createManualHealthEvent;
